import React from "react";
import { motion } from "framer-motion";
import { WHY_CHOOSE } from "@/lib/content";

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-36 bg-gradient-to-b from-transparent via-[#121216] to-transparent"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-8 h-px bg-[#1F5EFF]" />
                <span className="font-mono-alt text-[12px] text-[#1F5EFF]">
                  Why WTD
                </span>
              </div>
              <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-white leading-[1.02]">
                Precision is
                <br />
                <span className="text-white/50">not optional.</span>
              </h2>
              <p className="mt-8 text-white/55 text-base md:text-lg max-w-md leading-relaxed">
                Every panel, every seam, every edge — inspected under focused
                lighting. This is the standard we hold every vehicle to,
                without exception.
              </p>
              <div className="mt-10 h-px w-24 bg-white/20" />
              <div className="mt-6 font-mono-alt text-[10px] text-white/40">
                Experienced · Precise · Honest
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {WHY_CHOOSE.map((w, i) => (
              <motion.div
                key={w.num}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
                className="group relative bg-[#17171c] border border-white/12 rounded-2xl p-7 md:p-8 hover:border-[#1F5EFF]/40 transition-colors"
                data-testid={`why-item-${i}`}
              >
                <div className="font-mono-alt text-[11px] text-[#1F5EFF]">
                  {w.num}
                </div>
                <div className="mt-6 font-display text-xl md:text-[22px] text-white leading-snug">
                  {w.title}
                </div>
                <p className="mt-3 text-sm text-white/55 leading-relaxed">
                  {w.copy}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
